import { LuSlidersHorizontal } from 'react-icons/lu';

import { Badge } from '@/components/ui/badge';

export const AmendmentBadge = () => (
    <Badge
        variant="outline"
        className="gap-1 border-transparent bg-purple-100 px-1.5 py-0 text-[10px] leading-4 text-purple-700"
    >
        <LuSlidersHorizontal className="h-2.5 w-2.5" />
        Amended
    </Badge>
);
